import * as React from "react"
import {Skeleton, Box, Typography} from "@mui/material";
import { PieAmchartSeeker, IconSeeker } from "@ui-seeker/core"

import { TitleWithPopover } from "@components";
import { usePricingDiscountRoleConfig } from "../../@hooks";
import usePriceDiscountWidget from "./hook";
import PriceDiscountOffersChartFooter from "./Footer";

const HEIGHT = 480


export default function PriceDiscountOffersChart() {
	const { isLoading, data, chartColors } = usePriceDiscountWidget()
	const { isStandardUser } = usePricingDiscountRoleConfig()

	if (isLoading) return <Skeleton variant="rectangular" height={HEIGHT} />
	if (!data.length) return <></>

	return <Box>
		<PieAmchartSeeker
			rootID="OffersComparion"
			data={data}
			extraFooter={<PriceDiscountOffersChartFooter/>}
			title={<TitleWithPopover title="Offers Comparison"/>}
			series={[{
				yField: 'label',
				xField: "value",
				innerRadius: 60,
			}]}
			sx={{ height: HEIGHT }}
			chartProps={{
				startAngle: 180,
				endAngle: 360,
				enabledPDF: false,
				root: {
					colors: chartColors
				},

			}}
		/>
	</Box>
}
